import { IconMoodBoy } from '@tabler/icons-react'

import { AstraIcon } from '~/astra'
import { AgeGroupCode } from '~/clients/derived-api-types'
import { useAgeGroup } from '~/storm'

type Props = {
    ageGroupCode?: AgeGroupCode | null
    iconOnly?: boolean
}

export const AgeGroup = ({ ageGroupCode, iconOnly = false }: Props) => {
    const ageGroup = useAgeGroup({ where: { age_group_code: 'child' } })
    if (ageGroupCode === 'child') {
        return iconOnly ? (
            <AstraIcon icon={IconMoodBoy} />
        ) : (
            <div className="py-0\\.5 flex items-center gap-1 rounded border px-2">
                <AstraIcon icon={IconMoodBoy} />
                {ageGroup?.display_name || 'Barn'}
            </div>
        )
    }
    return null
}
